var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoCircleO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 21.3346C66.2498 21.3346 79.1665 34.2513 79.1665 50.5013C79.1665 66.7513 66.2498 79.668 49.9998 79.668C33.7498 79.668 20.8332 66.7513 20.8332 50.5013C20.8332 34.2513 33.7498 21.3346 49.9998 21.3346ZM49.9998 17.168C31.6665 17.168 16.6665 32.168 16.6665 50.5013C16.6665 68.8346 31.6665 83.8346 49.9998 83.8346C68.3332 83.8346 83.3332 68.8346 83.3332 50.5013C83.3332 32.168 68.3332 17.168 49.9998 17.168Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8335 42.168H54.1668V71.3346H45.8335V42.168Z",
    fill: "#FCFDFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8335 29.668H54.1668V38.0013H45.8335V29.668Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleO);
export default __webpack_public_path__ + "static/media/info-circle-o.126acb9e79c9a3a834bcd806d8b93266.svg";
export { ForwardRef as ReactComponent };